<template>
  <div class="content-430">
    <header class="header">
      <div class="title">
        <p>{{ schoolName }}{{ month }}教师考勤确认单</p>
        <div v-show="progress.success < progress.total" class="realtime">
          <Spin size="small"><Icon
            type="ios-loading"
            size="18"
            class="spin-icon-load"
          ></Icon></Spin>工资发放中 (
          <span style="font-size: 16px">{{ progress.success }}</span>/{{ progress.total }}
          )
        </div>
      </div>

      <div v-if="detailsInfo && portOrg == 0" class="btn-main">
        <Button
          v-if="detailsInfo.sheetSts == 0"
          class="cfm-btn"
          type="primary"
          @click="handleCfm"
        >确认单无误，提交确认</Button>
        <Button
          v-if="detailsInfo.sheetSts != 0"
          class="m-16-430"
          type="primary"
          disabled
        >已确认</Button>
        <Button
          v-if="detailsInfo.sheetSts == 2"
          class="m-16-430"
          type="error"
          @click="handleCancle"
        >账单有误，撤回确认</Button>
      </div>
      <div v-if="detailsInfo && portOrg == 2" class="btn-main">
        <Button
          v-if="Number(detailsInfo.sheetSts) > 2"
          class="m-16-430"
          type="primary"
          disabled
        >学校已确认</Button>
        <Button
          v-if="Number(detailsInfo.sheetSts) == 2"
          class="m-16-430"
          type="primary"
          @click="handleSchoolCfm"
        >待学校确认</Button>
      </div>
    </header>
    <div class="search-wrap">
      <Form
        ref="searchForm"
        label-position="right"
        class="search-list-430 search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">
          <FormItem>
            <Input
              v-model="searchConds.teacherName"
              placeholder="教师姓名"
              clearable
              class="search-input-430"
            ></Input>
          </FormItem>

          <FormItem>
            <Select
              v-model="searchConds.itemSts"
              placeholder="查看确认单状态"
              class="search-select-430"
            >
              <Option
                v-for="item in confirmList"
                :key="item.id"
                :value="item.id"
              >{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Select
              v-model="searchConds.settleSts"
              placeholder="结算状态"
              class="search-select-430"
            >
              <Option
                v-for="item in settleList"
                :key="item.id"
                :value="item.id"
              >{{ item.name }}</Option>
            </Select>
          </FormItem>
          <Button
            type="primary"
            style="margin-right: 16px"
            @click="handleSearch"
          >查询</Button>
          <Button @click="handleReset">重置</Button>
        </Row>
      </Form>
    </div>
    <TeaAttendTable
      ref="teaAttendTableRef"
      :table-list="tableList"
      :table-columns="tableColumns"
      :table-loading="tableLoading"
      :cfm-count-num="cfmCountNum"
      :total="pageInfo.total"
      :page-type="`schoolDetailed`"
      :year-term="yearTerm"
      :school-name="schoolName"
      :month="month"
      :sheet-id="sheetId"
      :details-info="detailsInfo"
      @on-page-change="onPageChange"
      @on-page-size-change="handleSizeChange"
      @on-export="handleExport"
      @on-records="onRecords"
      @on-reissue="handleReissue"
      @on-cancel="handleCancel"
      @on-adc-finish="onAdcFinish"
      @on-delete="onDeleteFun"
      @on-batchupload="onBatchupload"
    ></TeaAttendTable>
    <ExportModal ref="exportModalRef" @on-submit="onExSubmit"></ExportModal>

    <UploadAttend
      ref="uploadAttendRef"
      :sheet-id="sheetId"
      :month="month"
      :school-name="schoolName"
      @on-submit="onUploadSubmit"
    ></UploadAttend>

    <RecordsList ref="recordsListRef" :sheet-id="sheetId"></RecordsList>
    <!-- 补发 组件 -->
    <ReissueModal
      ref="reissueModalRef"
      @on-finish="onReissueFinish"
    ></ReissueModal>
    <!-- 运营确认组件 -->
    <OperationCfm
      ref="operationCfmRef"
      :sheet-id="sheetId"
      @on-finish="onOCfmFinish"
    ></OperationCfm>
    <DetailedStep
      ref="detailedStepRef"
      :cfm-count-num="cfmCountNum"
      :sheet-id="sheetId"
      :school-id="schoolId"
      :details-info="detailsInfo"
      @on-fail-list="onFailList"
      @on-schCfmFinish="onSchCfmFinish"
      @on-financialCfmFinish="onFinancialCfmFinish"
      @on-checkGzFinish="onCheckGzFinish"
    ></DetailedStep>
    <ApproveFailList
      ref="approveFailListRef"
      :sheet-id="sheetId"
    ></ApproveFailList>
    <MergeGzBatch
      ref="mergeGzBatchRef"
      :sheet-id="sheetId"
      @on-finish="onMergeGzBtFinish"
    ></MergeGzBatch>
  </div>
</template>

<script>
import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle';

import { settleList, teaList, schList, recordsColumns } from './assets/data/index';
import TeaAttendTable from './assets/components/TeaAttendTable.vue';
import RecordsList from './assets/components/RecordsList.vue';
import financeCenterApi from '@/request/financeCenter/index.js';
import TeaAttend from './mixins/teaAttend';
import ExportModal from './assets/components/ExportModal.vue';
import UploadAttend from './assets/components/UploadAttend.vue';
import ReissueModal from './assets/components/ReissueModal.vue';
import OperationCfm from './assets/components/OperationCfm.vue';
import DetailedStep from './assets/components/DetailedStep.vue';
import ApproveFailList from './assets/components/ApproveFailList.vue';
import MergeGzBatch from './assets/components/MergeGzBatch.vue';

import { getNextMonth } from '@/utils/moment.js';
import timer from '@/utils/timer.js';

export default {
  components: { UploadAttend, TeaAttendTable, RecordsList, ExportModal, ReissueModal, OperationCfm, DetailedStep, ApproveFailList, MergeGzBatch },
  mixins: [TeaAttend],
  data() {
    return {
      confirmList: [...teaList], // 确认单列表
      settleList: [...settleList], // 结算状态列表
      tableColumns: [
        key('教师确认单ID', 'itemId', tableColumnsWidth.type4, {
          fixed: 'left'
        }),
        key('教师姓名', 'userName', 100, {
          fixed: 'left'
        }),
        slot('学校', 'schoolName', tableColumnsWidth.type6, {
          fixed: 'left'
        }),
        key('教师手机号码', 'phoneNo', 130, {
          fixed: 'left'
        }),
        slot('月份', 'beginDate', tableColumnsWidth.type2),
        key('本月出勤总数', 'signNum', 130),
        key('应结算金额（元）', 'payableAmt', tableColumnsWidth.type3),
        slot('补发/补扣金额（元）', 'supplementalAmt', tableColumnsWidth.type4),
        {
          renderHeader: (h, params) => {
            const handleClickMerge = () => {
              this.handleClickMerge(params);
            };
            return h(
              'div',
              {
                on: {
                  click: handleClickMerge
                }
              },
              [
                h('span', '合计金额（元）'), // 列名
                h('Icon', { props: { type: 'ios-build', class: 'cursor-pointer' }}) // 问号图标
              ]
            );
          },
          key: 'totalAmt',
          width: tableColumnsWidth.type3
        },
        // key('合计金额（元）', 'totalAmt', tableColumnsWidth.type3),
        key('本月实缴个税（元）', 'taxAmt', 170),
        key('实发金额（元）', 'realAmt', tableColumnsWidth.type3),
        key('补发/补扣说明', 'supplementalMsg', tableColumnsWidth.type3),

        slot('确认单状态', 'itemSts', tableColumnsWidth.type5),
        slot('结算状态', 'settleSts', 100),
        key('生成时间', 'createTime', 170),
        key('更新时间', 'operateTime', 170),
        slot('操作', 'action', 220, {
          fixed: 'right'
        })
      ],
      searchConds: {
        schoolId: this.$route.query.schoolId,
        startDate: '',
        endDate: '',
        itemSts: '',
        settleSts: '',
        yearCode: '',
        termCode: '',
        teacherName: ''
      },
      schoolName: this.$route.query.schoolName,
      beginDate: this.$route.query.beginDate,
      sheetId: this.$route.query.sheetId,
      schoolId: this.$route.query.schoolId,
      yearTerm: this.$route.query.yearTerm,
      detailsInfo: null, // 学校确认单详情信息
      portOrg: localStorage.getItem('portOrg'),
      progress: {
        total: 0,
        ongoing: 0,
        success: 0
      },
      progressStatus: 1 // 1: 初始化 2 : 有未完成发放工资的 3 ： 全部发放完成
    };
  },
  computed: {
    month() {
      const day = this.beginDate.split('-');
      return `${day[0]}年${day[1]}月`;
    }
  },
  created() {
    this.getSchoolSignConfirmDetails();
  },
  mounted() {
    console.log(this.beginDate, 'beginDate');
    this.initParameter();
  },
  destroyed() {
    timer.clearTimer('settlementProgress');
  },
  methods: {

    initParameter() {
      const date = this.beginDate.split(' ')[0];
      this.searchConds.startDate = `${date} 00:00:00`;
      this.searchConds.endDate = `${getNextMonth(date)} 00:00:00`;

      this.handleSearch();
    },
    handleReset() {
      this.searchConds.teacherName = '';
      this.searchConds.sheetSts = '';
      this.searchConds.settleSts = '';
      this.searchConds.itemSts = '';
      this.handleSearch();
    },
    handleSearch() {
      this.pageInfo.pageNum = 1;

      this.getTeachersSignConfirmList();
    },
    // 学校确认
    handleSchoolCfm() {
      this.$refs.detailedStepRef.handleSchoolCfm();
    },
    // 点击合计金额
    handleClickMerge() {
      const sheetSts = Number(this.detailsInfo.sheetSts);
      if (sheetSts > 2 || sheetSts == 1) {
        this.$Message.warning('学校已确认，不可进行批量操作');
        return null;
      }
      this.$refs.mergeGzBatchRef.handleShow();
    },
    // 校验失败明细
    onFailList(item) {
      this.$refs.approveFailListRef.handleShow(item.actType);
    },
    // 学校确认完成
    onSchCfmFinish() {
      this.getSchoolSignConfirmDetails();
      this.getTeachersSignConfirmList();
    },
    // 财务确认-驳回 完成
    onFinancialCfmFinish() {
      this.getSchoolSignConfirmDetails();
      this.getTeachersSignConfirmList();
    },
    // 工资发送核对完成
    onCheckGzFinish() {
      this.getSchoolSignConfirmDetails();
      this.getTeachersSignConfirmList();
    },
    // 运营提交确认 点击
    handleCfm() {
      this.$refs.operationCfmRef.handleShow();
    },
    onDeleteFun(row) {
      this.$Modal.confirm({
        title: `确认删除${row.name}的教师考勤确认单吗？删除后不可恢复！`,
        onOk: () => {
          financeCenterApi.delSheetItem({
            itemId: row.itemId
          }).then((res) => {
            if (res.status == 200) {
              this.$Message.success('操作成功');
              this.getSchoolSignConfirmDetails();
              this.getTeachersSignConfirmList();
            }
          });
        },
        onCancel: () => {

        }
      });
    },
    // 运营确认撤回 点击
    handleCancle() {
      this.$Modal.confirm({
        title: '是否确认撤回？',
        onOk: () => {
          this.toWithdrawConfirmed();
        },
        onCancel: () => {

        }
      });
    },
    // 合并工资批量设置完成
    onMergeGzBtFinish() {
      this.getTeachersSignConfirmList();
    },

    async getSettlementProgress() {
      const res = await financeCenterApi.getSettlementProgressApi({
        sheetId: this.sheetId
      });
      if (res.status == 200) {
        for (const k in res.message) {
          this.progress[k] = res.message[k] !== null ? res.message[k] : 0;
        }

        if (this.progress.total === this.progress.success) {
          timer.clearTimer('settlementProgress');
          if (this.progressStatus == 2) {
            location.reload();
          }
          this.progressStatus = 3;
        } else {
          this.progressStatus = 2;
        }

        // this.progress = res.message
      }
    },
    // 获取学校详情确认单
    async getSchoolSignConfirmDetails() {
      const res = await financeCenterApi.getSchoolSignConfirmDetailsApi({
        sheetId: this.sheetId
      });
      if (res.status == 200) {
        this.detailsInfo = res.message;
        if (this.detailsInfo.settleSts == 2) {
          this.getSettlementProgress();
          if (this.portOrg == 0) {
            timer.clearTimer('settlementProgress');
            timer.addTimer('settlementProgress', this.getSettlementProgress, 3000);
          }
        }
      }
    },
    onUploadSubmit(row) {
      if (!row.failNum) {
        this.$refs.uploadAttendRef.handleHide();
      }
      if (row.successNum) {
        this.$Message.success('新增成功');
        this.handleSearch();
      }
    },
    async toWithdrawConfirmed() {
      console.log(financeCenterApi);
      const res = await financeCenterApi.toWithdrawConfirmedApi({
        sheetId: this.sheetId
      });
      if (res.status == 200) {
        this.$Message.success('操作成功');
        this.$refs.detailedStepRef.getSchoolApprovalPayrollList();
        this.getSchoolSignConfirmDetails();
        this.getTeachersSignConfirmList();
      }
    },
    // 运营确认完成
    onOCfmFinish() {
      this.getSchoolSignConfirmDetails();
      this.$refs.detailedStepRef.getSchoolApprovalPayrollList();
      this.getTeachersSignConfirmList();
    },
    // 操作日志
    onRecords() {
      this.$refs.recordsListRef.handleShow();
    },
    // 列表页码改变
    onPageChange(page) {
      this.pageInfo.pageNum = page;
      this.getTeachersSignConfirmList();
    },
    // 列表页码改变
    handleSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.pageInfo.pageNum = 1;
      this.getTeachersSignConfirmList();
    },
    // 导出-弹框
    handleExport() {
      this.$refs.exportModalRef.handleShow();
    },
    // 批量导入-弹框
    onBatchupload() {
      this.$refs.uploadAttendRef.handleShow();
    },

    // 取消
    handleCancel(itemId) {
      this.setCancelPayroll(itemId);
    },
    // 补发
    handleReissue(itemId) {
      this.$refs.reissueModalRef.handleShow(itemId);
    },
    // 添加教师考勤确认成功
    onAdcFinish() {
      this.getTeachersSignConfirmList();
    },
    // 补发成功
    onReissueFinish() {
      this.getTeachersSignConfirmList();
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  text-align: center;
  margin-bottom: 16px;
  .title {
    display: flex;
    justify-content: center;
    .realtime {
      position: relative;
      top: -4px;
      margin-left: 8px;
      background-color: #f8b66e;
      padding: 4px 10px;
      border-radius: 18px;
      font-size: 16px;
      color: #fff;
      display: flex;
      span {
        color: #488ffa;
      }
      .spin-icon-load {
        animation: ani-spin 1s linear infinite;
      }
      @keyframes ani-spin {
        from {
          transform: rotate(0deg);
        }
        50% {
          transform: rotate(180deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
    }
  }

  p {
    font-size: 18px;
    color: #333;
    font-weight: bold;
    margin-bottom: 8px;
  }
  .btn-main {
    position: absolute;
    right: 20px;
    top: 0;
  }
}
</style>
